<template>
  <modal
    name="mediaModal"
    adaptive
    :width="1000"
    :height="600"
    classes="wf-shadow-xl wf-rounded-lg wf-bg-gray-100"
    @before-open="beforeOpen"
    @closed="closed"
  >
    <div class="wf-h-full wf-flex wf-flex-col">
      <ul class="wf-flex wf-flex-row wf-w-full wf-justify-between wf-border-b">
        <li
          class="wf--mb-px wf-block wf-w-1/3 wf-text-center wf-border wf-border-r-0 hover:wf-bg-gray-300"
          :class="{'wf-bg-gray-300': selectedTab === srcOption.value}"
          v-for="srcOption in srcOptions"
          :key="srcOption.value"
          :value="srcOption.value"
          @click.prevent="selectTab(srcOption.value)"
        >
          <a
            class="wf-block wf-py-2 wf-px-4 wf-text-blue-700 wf-font-semibold"
            href="#"
          ><i class="fas" :class="[...srcOption.icon]"></i> {{ srcOption.text }}</a>
        </li>
      </ul>

      <div v-if="selectedTab==='media'" class="wf-flex-1 wf-flex wf-h-full">
        <div
          class="wf-overflow-scroll wf-p-3 wf-relative wf-bg-white image-media-container"
          :class="selectedImage ? ['wf-w-3/4'] : ['wf-w-full']"
        >
          <div class="wf-mt-2 wf-flex wf-flex-wrap">
            <div
              v-for="image in originalImages"
              :key="image.id"
              class="wf-flex wf-items-center wf-justify-center wf-mb-4 wf-w-1/6"
            >
              <div
                @click.prevent="selectedImage === image ? (selectedImage = null) : (selectedImage = image)"
                :class="thumbnailClasses(image)"
                class="media-thumbnail wf-cursor-pointer wf-rounded-lg wf-border-4 wf-relative hover:wf-border-blue-600 wf-border-transparent"
              >
                <div
                  class="wf-rounded wf-bg-center wf-bg-cover wf-relative wf-h-full wf-w-full"
                  :style="`background-image: url(${image.path})`"
                ></div>
                <div
                  v-if="selectedImage === image"
                  style="top: -10px;right: -10px;"
                  class="wf-absolute wf-bg-blue-600 wf-flex wf-h-5 wf-items-center wf-justify-center wf-rounded-full wf-text-white wf-text-xs wf-w-5"
                >
                  <i class="fas fa-check"></i>
                </div>
              </div>
            </div>
          </div>
          <label
            for="upload-image"
            class="wf-bottom-0 wf-right-0 wf-mr-4 wf-mb-4 wf-bg-blue-500 wf-border-radius wf-cursor-pointer wf-flex wf-h-12 wf-w-12 hover:wf-bg-blue-600 wf-shadow-md hover:wf-shadow-lg wf-items-center wf-justify-center wf-absolute wf-rounded-full wf-text-sm wf-text-white wf-uppercase wf-z-50"
          >
            <i class="fas fa-upload"></i>
            <input @change="uploadImages" type="file" class="wf-hidden" multiple accept="image" id="upload-image" />
          </label>
        </div>
        <!--SELECTED IMAGE-->
        <div
          v-if="selectedImage"
          class="wf-flex wf-flex-col wf-border-l wf-p-4 wf-w-1/4 wf-bg-gray-100 wf-h-full image-media-container"
        >
          <div class="wf-flex wf-justify-center wf-items-center">
            <img :src="selectedImage.path" ref="selectedImage" class="wf-h-40 wf-shadow wf-rounded" alt="" />
          </div>
          <div class="wf-mt-2 wf-flex wf-justify-between wf-items-center">
          <span
            class="wf-font-light wf-lowercase wf-text-gray-600 wf-text-xs wf-tracking-wid wf-leading-tight"
            v-text="`${imageNaturalWidth}x${imageNaturalHeight}px`"
          >
          </span>
            <span class="wf-font-light wf-lowercase wf-text-gray-600 wf-text-xs wf-tracking-wide wf-leading-tight"
            >October 12th 1985</span
            >
          </div>
          <div class="wf-mt-4">
            <ul class="wf-flex wf-flex-col">
              <li class="wf-mt-3 wf-w-full">
              <span class="wf-block wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide"
              >alternative text</span
              >
                <input
                  type="text"
                  class="wf-w-full focus:wf-bg-gray-300 wf-text-xs wf-bg-gray-300 wf-text-gray-700 wf-border wf-rounded focus:wf-outline-none wf-px-2 wf-py-1"
                />
              </li>
              <li class="wf-mt-3 wf-w-full">
              <span class="wf-block wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide"
              >title</span
              >
                <input
                  type="text"
                  class="wf-w-full focus:wf-bg-gray-300 wf-text-xs wf-bg-gray-300 wf-text-gray-700 wf-border wf-rounded focus:wf-outline-none wf-px-2 wf-py-1"
                />
              </li>
              <li class="wf-mt-3 wf-w-full">
                <span class="wf-block wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">link</span>
                <input
                  readonly
                  @click.prevent="copyToClipboard"
                  class="wf-w-full focus:wf-outline-none focus:wf-bg-gray-300 wf-cursor-pointer wf-text-xs wf-bg-gray-300 wf-text-gray-500 wf-border wf-rounded wf-px-2 wf-py-1"
                  :value="selectedImage.path"
                />
              </li>
            </ul>
          </div>
          <div class="wf-mt-auto">
            <button
              @click.prevent="queueImage"
              class="wf-bg-green-500 focus:wf-outline-none hover:wf-bg-green-600 hover:wf-shadow-lg wf-py-2 wf-rounded-full wf-shadow wf-text-center wf-text-sm wf-text-white wf-uppercase wf-w-full"
            >
              Select image
            </button>
          </div>
        </div>
      </div><!--END Media Library-->

      <div v-if="selectedTab==='external'" class="wf-flex-1 wf-flex wf-h-full">
        <div class="wf-w-full wf-overflow-scroll wf-p-3 wf-relative wf-bg-white image-media-container" >
          <form class="wf-w-full wf-max-w-2xl">
            <div class="wf-flex wf-flex-wrap wf--mx-2 wf-mb-6">
              <div class="wf-w-full md:wf-w-1/3 wf-pl-4 wf-px-2 wf-mb-6 md:wf-mb-0">
                <label
                  class="wf-block wf-lowercase wf-tracking-wide wf-text-gray-700 wf-text-xs wf-font-bold wf-mb-2"
                  for="grid-first-name"
                >Link</label>
                <input
                  class="wf-appearance-none wf-block wf-w-full wf-bg-gray-200 wf-text-gray-700 wf-border wf-rounded wf-py-2 wf-px-3 wf-mb-3 wf-leading-tight focus:wf-outline-none focus:wf-bg-white"
                  id="grid-first-name"
                  type="text"
                  v-model="external.link"
                  placeholder="link"
                />
              </div>
              <div class="wf-w-full md:wf-w-1/3 wf-px-2">
                <label
                  class="wf-block wf-lowercase wf-tracking-wide wf-text-gray-700 wf-text-xs wf-font-bold wf-mb-2"
                  for="grid-title"
                >Title</label>
                <input
                  class="wf-appearance-none wf-block wf-w-full wf-bg-gray-200 wf-text-gray-700 wf-border wf-border-gray-200 wf-rounded wf-py-2 wf-px-3 wf-leading-tight focus:wf-outline-none focus:wf-bg-white focus:wf-border-gray-500"
                  id="grid-title"
                  v-model="external.title"
                  type="text"
                />
              </div>
              <div class="wf-w-full md:wf-w-1/3 wf-px-2">
                <label
                  class="wf-block wf-lowercase wf-tracking-wide wf-text-gray-700 wf-text-xs wf-font-bold wf-mb-2"
                  for="grid-alt-name"
                >Alt text</label>
                <input
                  class="wf-appearance-none wf-block wf-w-full wf-bg-gray-200 wf-text-gray-700 wf-border wf-border-gray-200 wf-rounded wf-py-2 wf-px-3 wf-leading-tight focus:wf-outline-none focus:wf-bg-white focus:wf-border-gray-500 pla"
                  id="grid-alt-name"
                  v-model="external.alt"
                  type="text"
                />
              </div>
            </div>
            <div class="wf-flex wf-pl-2">
              <button
                type="button"
                class="wf-px-2 wf-w-full wf-py-1 wf-uppercase wf-bg-green-500 wf-block wf-text-white hover:wf-bg-green-600 wf-rounded focus:wf-outline-none"
                :disabled="!external.link"
                @click.prevent="queueExternalLinks"
              ><i class="fas fa-plus"></i></button>
            </div>
          </form>
        </div>
      </div><!--END External-->

      <div v-if="selectedTab==='preview'" class="wf-flex-1 wf-flex wf-h-full">
        <div class="wf-w-full wf-overflow-scroll wf-p-3 wf-relative wf-bg-white image-media-container " >
          <div class="wf-mt-2 wf-flex wf-flex-wrap">
            <!--draggable
              class="wf-flex wf-flex-row wf-flex-wrap wf-w-full"
              v-model="mediaAssets"
              group="mediaAssets"
              handle=".column-handle"
            -->
              <div
                v-for="image in mediaAssets"
                :key="image.id"
                :data-id="image.id"
                class="wf-flex wf-items-center wf-justify-center wf-mb-4 wf-w-1/2 sm:wf-w-1/2 md:wf-w-1/4 lg:wf-w-1/6"
              >
                <div
                  :class="thumbnailClasses(image)"
                  class="wf-relative media-thumbnail wf-cursor-pointer wf-rounded-lg wf-border-2 wf-relative hover:wf-border-blue-600 wf-border-transparent hover-parent"
                >
                  <div
                    class="wf-rounded wf-bg-center wf-bg-cover wf-relative wf-h-full wf-w-full"
                    :style="`background-image: url(${image.link})`"
                  ></div>

                  <button
                    type="button"
                    style="bottom: 5px; right: 5px;"
                    @click.prevent="removeMediaItem(image)"
                    class="wf-absolute hover-target wf-bg-gray-100 wf-border wf-border-gray-400 wf-flex wf-h-5 wf-items-center wf-justify-center wf-rounded-sm wf-text-red-500 wf-text-xs wf-w-5 focus:wf-outline-none"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </div>
              </div>
            <!--/draggable-->
          </div>
          <button
            v-if="mediaAssets.length"
            class="wf-bottom-0 wf-px-3 wf-py-2 wf-right-0 wf-mr-4 wf-mb-4 wf-bg-green-500 hover:wf-bg-green-600 wf-border-radius wf-cursor-pointer wf-flex wf-shadow-md hover:wf-shadow-lg wf-items-center wf-justify-center wf-absolute wf-rounded-full wf-text-sm wf-text-white wf-uppercase wf-z-50"
            @click.prevent="updateMediaLibrary"
          ><i class="fas fa-upload wf-mr-1"></i> Update Media</button>
        </div>
      </div><!--END Preview-->

    </div><!--END-->
  </modal>
</template>

<script>
import axios from "axios";
import ArrayManipulation from "../mixins/ArrayManipulation";
import { UuidGenerator } from "../UuidGenerator";

export default {
  mixins: [ArrayManipulation],
  data() {
    return {
      selectedTab: 'media',
      currentImage: null,
      alt: null,
      device: null,
      module: null,
      imageNaturalHeight: 0,
      imageNaturalWidth: 0,
      selectedImage: null,
      images: [],
      imageElement: null,
      video: null,
      sectionIndex: null,
      rowIndex: null,
      columnIndex: null,
      componentIndex: null,
      external: {
        link: null,
        title: null,
        alt: null
      },
      mediaAssets: []
    };
  },

  watch: {
    selectedImage(value) {
      if (!value) {
        return;
      }
      this.$nextTick(() => {
        if (!this.$refs.selectedImage) {
          return;
        }
        this.imageNaturalWidth = this.$refs.selectedImage.naturalWidth;
        this.imageNaturalHeight = this.$refs.selectedImage.naturalHeight;
      });
    }
  },

  computed: {
    srcOptions() {
      return [
        {value: 'media', text: 'Media Library', icon: 'fa-images'},
        {value: 'external', text: 'External Links', icon: 'fa-link'},
        {value: 'preview', text: 'Preview', icon: 'fa-play-circle'},
      ]
    },

    element() {
      let element = {
        section: this.sectionIndex,
        row: this.rowIndex,
        column: this.columnIndex,
        component: this.componentIndex,
        componentSection: this.componentSectionIndex,
        componentRow: this.componentRowIndex,
        componentColumn: this.componentColumnIndex,
        componentComponent: this.componentComponentIndex
      };

      let newElement = Object.keys(element)
        .filter(key => element[key] != null)
        .reduce((obj, key) => {
          obj[key] = element[key];
          return obj;
        }, new Object());

      return newElement;
    },

    originalImages() {
      return this.images.filter(image => image.size == "original");
    },

    assets() {
      return this.$store.getters["assetModule/assets"];
    }
  },

  methods: {
    selectTab(value) {
      this.selectedTab = value
    },
    newImages(image, withSizes = false) {
      let images = [
        {
          alt: this.alt,
          image: image.path,
          size: image.size,
          element: this.imageElement,
          touched: false
        }
      ];
      if (withSizes) {
        let sizes = this.images
          .filter(arrayImage => arrayImage.file_id === image.id)
          .map(arrayImage => {
            return {
              alt: this.alt,
              image: arrayImage.path,
              size: arrayImage.size,
              element: this.imageElement,
              touched: false
            };
          });
        sizes.push(...images);
        images = sizes;
      }
      return images;
    },

    thumbnailClasses(image) {
      let classes = this.selectedImage ? ["wf-h-24", "wf-w-24"] : ["wf-h-32", "wf-w-32"];
      if (this.selectedImage === image) {
        classes.push("wf-border-blue-600");
      }
      return classes;
    },
    beforeOpen(event) {
      this.sectionIndex = event.params.section;
      this.rowIndex = event.params.row;
      this.device = event.params.device;
      this.columnIndex = event.params.column;
      this.componentIndex = event.params.component;
      this.componentSectionIndex = event.params.componentSection;
      this.componentRowIndex = event.params.componentRow;
      this.componentColumnIndex = event.params.componentColumn;
      this.componentComponentIndex = event.params.componentComponent;
      this.module = event.params.module;
      this.imageElement = event.params.element;
      if (event.params.currentImage) {
        this.currentImage = event.params.currentImage;
        this.selectedImage = this.currentImage.image;
      }
      if (this.imageElement === "sourceMedia") {
        let mediaElements = event.params.mediaElements;

        if (mediaElements.length) {
          this.mediaAssets = mediaElements.map( item => {
            return {
              id: item.id,
              link: item.url,
              alt: item.alt,
            }
          })
        } else {
          this.mediaAssets = [];
        }
      }
      this.getImages();
    },
    closed() {
      this.images = [];
      this.imageElement = null;
      this.sectionIndex = null;
      this.device = null;
      this.rowIndex = null;
      this.columnIndex = null;
      this.componentIndex = null;
      this.componentSectionIndex = null;
      this.componentRowIndex = null;
      this.componentColumnIndex = null;
      this.componentComponentIndex = null;
      this.selectedImage = null;
      this.imageNaturalWidth = null;
      this.imageNaturalHeight = null;
    },
    formData(files) {
      let formData = new FormData();
      for (let x = 0; x < files.length; x++) {
        formData.append("files[]", files[x]);
      }
      return formData;
    },
    getImages() {
      axios
        .get("/files.json")
        .then(response => (this.images = response.data))
        .catch(error => console.log(error.response.data));
    },

    queueImage() {
      let mediaLibraryItem = Object.assign({}, this.selectedImage, {link: this.selectedImage.path});
      if (mediaLibraryItem.link) {
        this.handleMediaAssets(mediaLibraryItem)
      }
    },

    queueExternalLinks() {
      let externalItem = Object.assign({}, this.external, { id: new UuidGenerator().build()});
      if (externalItem.link) {
        this.handleExternalLinks(externalItem)
      }
    },

    addImage() {
      if (!this.selectedImage) {
        return;
      }
      this.handleImage();
      this.$modal.hide("imagesModal");
    },

    handleMediaAssets(mediaItem) {
      this.mediaAssets.push(mediaItem);
    },

    removeMediaItem(mediaItem) {
      return this.mediaAssets = this.mediaAssets.filter(item => item.id !== mediaItem.id)
    },

    updateMediaLibrary() {
      let images = this.mediaAssets.map( item => {
        return {
          id: item.id,
          url: item.link,
          alt: item.alt,
        }
      })
      this.addToObject(this.module, { images: images }, 'content')
      this.$modal.hide('mediaModal')
    },

    handleExternalLinks(externalLink) {
      this.mediaAssets.push(externalLink);
      this.external = this.$options.data.apply(this)['external']
    },

    handleImage() {
      //console.log(this.imageElement, 'imageElement...')
      if (this.imageElement === "videoPoster") {
        return this.handleVideoPoster();
      }
      if (this.imageElement === "sourceImage") {
        //return this.handleSourceImage();
      }
      return this.handleBackgroundImage();
    },
    handleVideoPoster() {
      let videoLink = this.video ? this.video.video : "";
      this.removeFromArray(this.module, [this.video], "assets", this.device);
      this.addToArray(
        this.module,
        [
          {
            video: videoLink,
            poster: this.selectedImage
          }
        ],
        "assets",
        this.device
      );
    },
    handleSourceImage() {
      let images = this.newImages(this.selectedImage, true);
      this.removeFromArray(this.module, [this.currentImage], "assets", this.device);
      this.addToArray(this.module, images, "assets", this.device);
    },
    handleBackgroundImage() {
      this.removeFromArray(this.module, [this.currentImage], "assets", this.device);
      this.addToArray(this.module, this.newImages(this.selectedImage), "assets", this.device);
    },
    copyToClipboard(event) {
      event.target.select();
      document.execCommand("copy");
      window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty();
    },
    uploadImages(event) {
      if (!event.target.files.length) {
        return;
      }
      axios
        .post("/files", this.formData(event.target.files), {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => this.images.push(...response.data.data))
        .catch(error => console.log(error.response.data));
    }
  }
};
</script>

<style lang="css">
  .hover-parent .hover-target {
    display: none;
  }

  .hover-parent:hover .hover-target {
    display: block;
  }
</style>
